import { createContext, useContext } from 'react'

import type { IAllWidgetParams } from '@core/types'

/**
 * ParamsContext to carry resolved widget params for reusable components.
 * for any component.
 */
export const ParamsContext = createContext<IAllWidgetParams | undefined>(
  undefined,
)

/**
 * useContextParams hook for passing widget params into reusable components.
 */
export function useContextParams() {
  const params = useContext(ParamsContext)
  if (!params) {
    throw new Error('Params not found in the context')
  }
  return params
}
